<template>
  <header class="layout__col-2-1 header">
    <SkeletonBlock
      class="header__loading"
      width="140px"
      height="12px"
    ></SkeletonBlock>
  </header>
</template>

<script>
export default {
  name: 'PageSkeleton',
}
</script>
